import { Box, Button, Card, Dialog, DialogActions, DialogContent, DialogContentText, DialogProps, DialogTitle, Divider, Icon, useTheme } from "@mui/material";
import { LatLngBounds, TileLayer } from "leaflet";
import { tilesNames } from "./tiles";
import { HidroMap } from "./mapa";
import { HidroLayer, HidroLayerGroup } from "./layers";
import { useEffect, useState } from "react";

interface Props extends DialogProps {
  onAdd?: () => void;
  layerGroup?: HidroLayerGroup;
}

export const SelectTileModal: React.FC<Props> = (props) => {
  const { onAdd, layerGroup, ...dialogProps } = props;
  const [selectedLayers, setSelectedLayers] = useState<PropsLayerComponent[]>([]);
  const [showMap, setShowMap] = useState(true);

  const layergroup = layerGroup;

  useEffect(() => {
    const bounds = layergroup?.getBounds();

    const layers: PropsLayerComponent[] = [];

    Object.entries(tilesNames).forEach(([key, value]) => {
      const layerData: PropsLayerComponent = {
        name: key,
        layer: value(false),
        bounds: bounds,
        selected: false,
        onSelect: undefined,
      };

      layerData.onSelect = () => {
        layerData.selected = !(layerData.selected ?? true);
        setSelectedLayers(layers.map(l => l));
      };

      layers.push(layerData);
    });
    setSelectedLayers(layers);
  }, [layergroup]);

  const handleFeito = () => {
    if (!onAdd || !layergroup) return;

    setShowMap(false);
    setTimeout(() => {
      if (!onAdd || !layergroup) return;

      for (const selectedLayer of selectedLayers) {
        if (!selectedLayer.selected) continue;
        layergroup?.push(
          new HidroLayer({
            name: selectedLayer.name,
            showing: true,
            layer: selectedLayer.layer
          }));
      }
      onAdd();
    }, 0);

  };

  const handleClose = () => {
    setSelectedLayers([]);
    if (dialogProps.onClose) dialogProps.onClose({}, "backdropClick");
  };


  return <Dialog
    {...dialogProps}
    maxWidth="xs"
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <DialogTitle id="alert-dialog-title" variant="h6" component="h2">Layers</DialogTitle>
    <DialogContent>
      <Divider />
      <div style={{
        flex: 1,
        display: "flex",
        flexWrap: "wrap",
        overflowY: "auto",
        gap: '0px',
      }}>
        {showMap && selectedLayers.map((data, i) => <LayerComponent key={i} {...data} />)}
      </div>
    </DialogContent>
    <DialogActions>
      <Button onClick={handleClose}>Cancelar</Button>
      {selectedLayers.some(layer => layer.selected) && <Button variant="contained" onClick={handleFeito}>Adicionar</Button>}
    </DialogActions>
  </Dialog>;
};

interface PropsLayerComponent {
  name: string;
  layer: TileLayer;
  selected?: boolean;
  bounds?: LatLngBounds | null;
  onSelect?: () => void;
}
const LayerComponent: React.FC<PropsLayerComponent> = ({ name, layer, bounds, onSelect, selected }) => {
  const pallete = useTheme().palette;
  const layerGroup: HidroLayerGroup = new HidroLayerGroup({
    name: "Map", showing: true, layers: [new HidroLayer({ name: "Map", showing: true, layer: layer })]
  });

  return <Box
    sx={{
      flex: 1,
      maxHeight: "116px",
      maxWidth: "96px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyItems: "center",
      p: "2px",
    }}>

    {/* Map */}
    <Card
      onClick={onSelect}
      sx={{
        width: "56px",
        height: "56px",
        position: selected ? 'relative' : undefined,
        ":hover": {
          border: `2px solid ${pallete.primary.main}`,
        }
      }}>
      {/* Selected */}
      {selected && <Box sx={{
        position: 'absolute',
        width: "100%",
        height: "100%",
        display: 'flex',
        alignItems: "center",
        justifyContent: "center",
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: "rgba(255, 255, 255, 0.7)",
        zIndex: 1000,
      }}>
        <Icon color="primary" sx={{ textJustify: 'center' }}>check</Icon>
      </Box>}

      {/* Mapa */}
      <HidroMap
        zoomBtn={false}
        style={{ width: "100%", height: "100%" }}
        attributionControl={false}
        hidroLayers={layerGroup}
        dragging={false}
        scrollWheelZoom={false}
        doubleClickZoom={false}
        boxZoom={false}
        keyboard={false}
        zoomControl={false}
        tapHold={false}
        touchZoom={false}
        bounds={bounds ?? undefined}
      />
    </Card>
    <div style={{ minHeight: "5px" }} />

    {/* Name */}
    <DialogContentText
      fontSize={11}
      textAlign={"center"}
    >{name}</DialogContentText>

  </Box >;
};